import React, { useState } from "react";
import usePost from "../../Hooks/usePost";

const InquiryForm = () => {
  const { postData, loading } = usePost();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!name || !email || !subject || !message) {
      setError("Please fill name, email, subject and message");
      return;
    }
    try {
      await postData("/contact/inquiry", {
        name,
        email,
        phone,
        subject,
        message,
      });
      setSuccess("Your inquiry was sent successfully");
      setName("");
      setEmail("");
      setPhone("");
      setSubject("");
      setMessage("");
    } catch (e) {
      setError(e.message || "Failed to send");
    }
  };

  return (
    <div className="max-w-lg mx-auto px-6 py-8">
      <h1 className="text-2xl font-semibold text-[#111827] mb-6">
        Send Inquiry
      </h1>
      {error && (
        <div className="mb-4 p-3 rounded bg-red-50 border border-red-200 text-red-700 text-sm">
          {error}
        </div>
      )}
      {success && (
        <div className="mb-4 p-3 rounded bg-green-50 border border-green-200 text-green-700 text-sm">
          {success}
        </div>
      )}
      <form onSubmit={submit} className="space-y-4">
        <input
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          placeholder="Your name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          placeholder="Your email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          placeholder="Phone (optional)"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <input
          className="w-full border border-gray-300 rounded-md px-3 py-2"
          placeholder="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <textarea
          className="w-full border border-gray-300 rounded-md px-3 py-2 h-36"
          placeholder="Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full px-4 py-2 text-white bg-[#133B6E] rounded-md hover:bg-[#0f2e55] disabled:bg-gray-400"
        >
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default InquiryForm;
